// Lib
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Flex, Heading, Button } from 'rebass';

// Components
import { StyledTextArea } from '../Input';
import ModalContent from './ModalContent';

const Content = styled(ModalContent)`
  max-width: 415px;
  width: 100%;
  flex-direction: column;
  padding-bottom: 30px;
`;

const FormButton = styled(Button)`
  width: 150px;
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

interface RejectNotesProps {
  closeModalHandler: VoidFunction;
}

const RejectReason: React.FC<RejectNotesProps> = ({ closeModalHandler }): JSX.Element => {
  const {
    data: { onReject },
  } = useSelector<any, any>(state => state.modal);

  return (
    <Content>
      <Flex width="100%" px={3} pt={4}>
        <Heading fontSize="30px" mb={2}>
          Reject reason
        </Heading>
      </Flex>
      <form onSubmit={onReject}>
        <StyledTextArea
          name="notes"
          placeholder="Type notes here…"
          required
          width="350px"
          height="30vh"
        />
        <Flex mt={5} justifyContent="center">
          <FormButton variant="primary" mr={3} onClick={closeModalHandler}>
            Cancel
          </FormButton>
          <FormButton type="submit" variant="primary">
            Reject
          </FormButton>
        </Flex>
      </form>
    </Content>
  );
};

export default RejectReason;
